import { Routes, Route } from 'react-router-dom';
import { PrivateRoute } from '@ohpen/react-auth';
import { Login } from '@pmp/pages';
import { AuthenticatedContent } from '@pmp/components';

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="*"
        element={
          <PrivateRoute>
            <AuthenticatedContent />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};
